import { Facet, FacetNavigation } from "../Sidebar/Filters";
import { getParamValueFromUrl } from "../Sidebar/FilterUrlHelpers";

export default (
  {
    categoryFacets,
    brandFacets,
    partFacets,
    specificationFacets,
    searchWithinFacet,
  }: FacetNavigation,
  ignoreCategoryFacets = false,
  pageUrl: string,
): boolean => {
  const getSelectedFilters = ({ sectionGroups }: Facet) => {
    let count = 0;
    sectionGroups?.forEach((sectionGroup) => {
      sectionGroup.groupItems.forEach((item) => {
        if (item.isSelected) {
          count++;
        }
      });
    });
    return count;
  };

  return (
    !!pageUrl &&
    ((!!getParamValueFromUrl(pageUrl, "manufacturer") &&
      !!getParamValueFromUrl(pageUrl, "model")) ||
      (!ignoreCategoryFacets ? Number(getSelectedFilters(categoryFacets)) : 0) +
        Number(getSelectedFilters(brandFacets)) +
        Number(getSelectedFilters(partFacets)) +
        Number(getSelectedFilters(specificationFacets)) +
        Number(getSelectedFilters(searchWithinFacet)) +
        (getParamValueFromUrl(pageUrl, "manufacturer")?.length > 0 ? 1 : 0) +
        (getParamValueFromUrl(pageUrl, "model")?.length > 0 ? 1 : 0) >
        1)
  );
};
